const minin = {
  data() {
    return {
      cols: [
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driver", label: "司机" },
        { prop: "money", label: "预支款余额", minwidth: 180, slot: 'moneydetail' },
        { prop: "typename", label: "打款类型", minwidth: 120 },
        { prop: "paymoney", label: "打款金额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "allmoney", label: "预支款现额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "isprint", label: "打印状态", slot: 'isprint' },
        { prop: "repaytime", label: "打款时间", minwidth: 120 },
        { prop: "remark", label: "备注" },
      ],
      getTotalProperty: ['paymoney'],
      btns: [
        {
          ...this.viewBtn,
          cb: (data) => {
            this.setData(data)
            this.viewMode = true
            this.title = '查看打款记录'
            this.$forceUpdate()
            this.showDialog()
          },
        },
        {
          ...this.editBtn,
          cb: (data) => {
            this.setData(data)
            this.viewMode = false
            this.title = '编辑打款记录'
            this.$forceUpdate()
            this.showDialog()
          },
        },
      ],
      title: '编辑打款记录',
      viewMode: false,
      mform: {
        paymoney: undefined,
        // photo: undefined,
        // photo: [{ url: '' }],
      },
      mrules: {
        paymoney: [
          {
            required: true,
            message: '请填写打款金额',
            trigger: 'blur',
          }
        ],
        // photo: [
        //   {
        //     required: true,
        //     message: '请上传打款凭证',
        //     trigger: 'blur',
        //   }
        // ],
      },
      mformCtrl: [
        {
          ...this.ctrls.license,
          label: "车牌号",
          disabled: true,
        },
        {
          label: "司机",
          keyName: "driver",
          err: "请填写司机",
          type: "text",
          disabled: true,
        },
        {
          label: "打款类型",
          keyName: "type",
          type: "select",
          options: [
            { label: '全部', value: 'money' },
            { label: '司机提成', value: 'commission' },
            { label: '差旅费', value: 'travel_expenses' },
            { label: '其他费用', value: 'other' },
          ],
          disabled: true,
        },
        {
          label: "打款金额",
          keyName: "paymoney",
          err: "请填写打款金额",
          type: "number",
        },
        {
          label: "打款时间",
          keyName: "repaytime",
          err: "请填写打款时间",
          type: "text",
          disabled: true,
        },
        {
          label: "打款凭证",
          keyName: "photo",
          tips: "最多上传2张图片",
          type: "file",
          max: 2,
        },
        {
          label: "备注",
          keyName: "remark",
          err: "请填写备注信息",
          type: "textarea",
          rows: 3,
        },
      ],
      getListUrl: 'payrec',
      baseParams: ['id', 'license'],
      showAllRecordBtn: false,
    };
  },
  methods: {
    dataObjHandler(v) {
      const o = {...v}
      const obj = {
        money: '全部',
        commission: '司机提成',
        travel_expenses: '差旅费',
        other: '其他费用',
      }
      o['typename'] = obj[o.type]
      return o
    },
    onSearchItemChange({ key, value }) {
      if (['starttime', 'edittime', 'fleet', 'month', 'type'].includes(key)) {
        this.getList()
      } else if (key == 'car_type_id') {
        console.log(key, value)
        let url = `car/getprepaidtype`;
        const params = {
          car_type_id: value,
        }
        this.post(url, params, ({ msg, prepaid_type }) => {
          if (msg) {
            this.formCtrl.map((c) => {
              if (c.keyName == "prepaid_type_id" &&
                  prepaid_type &&
                  prepaid_type.length) {
                c.options = prepaid_type.map((v) => {
                  return {
                    label: v.name,
                    value: v.id,
                  };
                });
              }
            });
          } else {
            this.$message({
              type: 'error',
              message: msg,
            });
          }
        }, err => {
          console.log(err)
        })
      }
    },
    setData({ id, cid, license, driver, type, photos, paymoney, remark, repaytime }) {
      // console.log(id)
      this.mform = {
        ...this.mform,
        id,
        cid,
        license,
        driver,
        type,
        photo: photos,
        paymoney,
        remark,
        repaytime,
      }
      this.mformCtrl.map(v => {
        if (v.keyName === 'paymoney') {
          if (type === 'money' || !type) {
            v.disabled = true
          } else {
            v.disabled = false
          }
        }
      })
      this.$forceUpdate()
      // console.log({ ...this.mform })
    },
    onModalSubmit() {
      // console.log({ ...this.mform })
      const { photo, paymoney, id, cid, remark } = this.mform
      // if (!photo || !photo.length) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请上传打款图片！'
      //   });
      // }
      if (!paymoney) {
        this.$message({
          type: 'warning',
          message: '请填写打款金额！'
        });
      }
      let url = `car/updatemoney`
      const params = {
        userid: this.user.id,
        cid,
        id,
        paymoney,
        remark,
      }
      if (photo) {
        params['photo'] = photo.map(v => {
          let result = v
          if (v.response && v.response.photo) {
            result = { url: v.response.photo }
          }
          return result
        })
      }

      this.loading = true
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交数据失败，请稍后重试！'
        });
      })
    },
    printSelected() {
      if (!this.selection.length) {
        this.$message({
          type: 'error',
          message: '请选择条目！'
        });
      }
      console.log(this.selection)
      const arr = this.selection.map(v => v.id)
      let url = `car/allprint`
      const params = {
        delList: arr,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '打印成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交数据失败，请稍后重试！'
        });
      })
    },
    printOne({ id }) {
      // console.log(id)
      let url = `car/singleprint`
      const params = {
        id,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '打印成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交数据失败，请稍后重试！'
        });
      })
    },
    showMoneyDetail({ cid, repaytime }) {
      console.log('repaytime', repaytime)
      this.$router.push(
        `/finance/moneyDetail?car_id=${cid}&repaytime=${repaytime}`
      );
    },
    getOption() {
      let url = `car/daypayoption`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ msg, fleet, prepaid_type, car_type }) => {
        if (msg) {
          console.log(fleet, prepaid_type)
          this.formCtrl.map((c) => {
            if (c.label == "车队") {
              c.options = fleet.map(v => {
                return {
                  label: v.nickname + '车队',
                  value: v.id,
                }
              })
            } else if (c.keyName == "fleet") {
              c.options = fleet.map((v) => {
                return {
                  label: v.nickname,
                  value: v.id,
                };
              });
            }
            // if (c.keyName == "prepaid_type_id") {
            //   c.options = prepaid_type.map((v) => {
            //     return {
            //       label: v.name,
            //       value: v.id,
            //     };
            //   });
            // }
            if (c.keyName == "car_type_id") {
              c.options = car_type.map((v) => {
                return {
                  label: v.name,
                  value: v.id,
                };
              });
            }
          });
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '删除失败，请稍后重试！'
        });
      })
    },
  },
  mounted() { },
}

export default minin